/**
 * LineItem Selectors
 */

import { getCart, hasValidCart } from './cart';
import { getCheckout, hasValidCheckout } from './checkout';

import { createSelector } from 'reselect';

const defaultList = [];

export const hasValidLineItems = (lineItems: GQL.ILicenseLineItem[]) => !lineItems.some(({ amount }) => amount === 0);

export const getCheckoutLineItems = createSelector<GQL.IViewer, GQL.IOrder | null, boolean, GQL.ILicenseLineItem[]>(
  [getCheckout, hasValidCheckout],
  (checkout, checkoutIsValid) => {
    return checkoutIsValid ? checkout!.license_line_items || defaultList : defaultList;
  },
);

export const getCartLineItems = createSelector<GQL.IViewer, GQL.ICart | null, boolean, GQL.ILicenseLineItem[]>(
  [getCart, hasValidCart],
  (cart, cartIsValid) => {
    return cartIsValid ? cart!.license_line_items || defaultList : defaultList;
  },
);

export const checkoutLicenseLineItemsAreValid = createSelector<GQL.IViewer, GQL.ILicenseLineItem[], boolean>(
  getCheckoutLineItems,
  hasValidLineItems,
);

export const cartLicenseLineItemsAreValid = createSelector<GQL.IViewer, GQL.ILicenseLineItem[], boolean>(
  getCartLineItems,
  hasValidLineItems,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/selectors/lineItem.ts